import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { getGatsbyImageData } from 'gatsby-source-sanity';

interface Props {
  heroImageId: string;
  alt: string;
}

export const HeroImage = ({ heroImageId, alt }: Props) => {
  const gatsbyImageData = getGatsbyImageData(
    heroImageId,
    {
      width: 100,
      height: 100,
      placeholder: 'dominantColor',
    },
    {
      projectId: process.env.GATSBY_SANITY_PROJECT_ID,
      dataset: process.env.GATSBY_SANITY_DATASET,
    }
  );

  return (
    <GatsbyImage
      image={gatsbyImageData}
      alt={alt}
      style={{ borderRadius: '50%' }}
    />
  );
};
